import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';

/**
 * Shared discard confirmation used when closing create flows with unsaved input.
 */
@Component({
  selector: 'app-discard-changes-modal',
  standalone: true,
  imports: [AlertModalComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <app-alert-modal
      [isOpen]="isOpen"
      title="Discard Changes?"
      description="You have unsaved changes. Are you sure you want to close?"
      primaryButtonText="Discard"
      secondaryButtonText="Continue Editing"
      (close)="cancel.emit()"
      (primaryAction)="confirm.emit()"
      (secondaryAction)="cancel.emit()"
    >
    </app-alert-modal>
  `,
})
export class DiscardChangesModalComponent {
  @Input() isOpen = false;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
